export default {
  country: {
    title: 'What country is your business located in?',
    titleFromProvider: 'Please verify what country your business is located in',
    supportText:
      'This sets your digital Coins to the proper local currency and makes you visible to relevant members.',
    disclaimer: 'Select the proper country now as this cannot be edited later.',
    notifyMe: 'Notify me'
  },
  connect: {
    title: 'How does your<br />business operate?',
    supportText:
      'Tell us how you manage your business and where you engage{break}with your members so we can give you the best options.',

    titleInStore: 'Please confirm all the ways your business operates',
    supportTextInStore:
      'Your business has a physical location, but you can also connect your online store. Please select a combination so we can give you the best options.',

    titleFromProvider: 'Please confirm all the ways your business operates',
    supportTextFromProvider:
      'It looks like you came from <strong>{provider}</strong>, so we know you’re operating online.<br />Please let us know if you have a physical location as well.',

    titleOnlineOnly: 'Confirm how does your<br />business operate',
    supportTextOnlineOnly:
      'Tell us how you manage your business and where you engage with<br />your members so we can give you the best options.',

    disclaimer:
      'At least one answer needs to be a Yes for Twism to offer your business the best options.',
    onlineDisclaimer:
      'Twism will soon be available for physical businesses in your country. We’ll send you an email when we launch.'
  },
  businessInformation: {
    title: 'Your business information',
    disclaimer:
      "You'll be able to add more business locations in your selected country through your dashboard after completing the initial onboarding.",
    fields: {
      name: {
        label: 'Business Name',
        placeholder: 'As you would like it to appear'
      },
      website: {
        label: 'Website',
        placeholder: 'website.com'
      },
      country: {
        label: 'Business Country'
      },
      phone: {
        label: 'Business Phone'
      },
      address: {
        label: 'Business Address',
        placeholder: 'Full address'
      },
      addressAdditional: {
        label: 'Business Address 2',
        placeholder: 'Apt, suite, unit, building, floor, etc.'
      },
      location: {
        label: 'City and State',
        placeholder: 'City and State'
      },
      zip: {
        label: 'ZIP/Postal Code',
        placeholder: '35005'
      },
      merchantId: {
        label: 'Merchant ID',
        placeholder: '123456'
      }
    }
  },
  categories: {
    title: 'Choose your business category',
    supportText:
      'Select the category that best fits your business so members can discover you.'
  },
  success: {
    title: 'Thanks for signing up!',
    description: `Since you're a physical business, our team will reach out soon to finalize your application. We'll contact you at this email: {EMAIL}`,
    disclaimer: 'We approve most applications within 24 hours.'
  }
};
